import { forwardRef } from 'react';
import {
  Box,
  CircularProgress,
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
  Tooltip,
  TooltipProps,
} from '@mui/material';

import { Icon, IconOption, IconProps } from '@components/base';

export type IconButtonProps = MuiIconButtonProps &
  Pick<IconProps, 'fontSize'> & {
    icon: IconOption;
    loading?: boolean;
    TooltipProps?: Omit<TooltipProps, 'children' | 'title'>;
  };

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      icon,
      TooltipProps: tooltipProps,
      size = 'small',
      loading,
      fontSize,
      title,
      disabled,
      ...rest
    },
    ref
  ) => (
    <Box position='relative'>
      <Tooltip title={title} {...tooltipProps}>
        <span>
          <MuiIconButton disabled={disabled || loading} ref={ref} size={size} {...rest}>
            <Icon fontSize={fontSize ?? (size === 'small' ? 'small' : 'inherit')} name={icon} />
          </MuiIconButton>
        </span>
      </Tooltip>

      {loading && (
        <Box position='absolute' top={0}>
          <CircularProgress color='primary' size={30} />
        </Box>
      )}
    </Box>
  )
);
